<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div
  class="qualification-line-container"
  [class.currently-playing-light]="match().startTime && !match().endTime && !viewOnly()"
  [class.currently-playing-dark]="match().startTime && !match().endTime && viewOnly()"
  [class.one-team-playing-warn]="!(match().startTime && !match().endTime) && !viewOnly() && (participantIsCurrentlyPlaying(participant1()!) || participantIsCurrentlyPlaying(participant2()!))"
  [class.admin-qualification-line-container]="!viewOnly()"
  [class.public-qualification-line-container]="viewOnly()"
>
  @if (!viewOnly()) {
    <div [class.table-light]="match().table?.name">
      {{ match().table?.name }}
    </div>
  }
  <div
    class="qualification-team"
    [class.text-winner]="participant1()?.isWinner === true"
    [class.text-grey]="participant1()?.isReady !== true"
    [matTooltip]="
      participantIsCurrentlyPlaying(participant1()!) ? 'Team is currently playing' : null
    "
  >
    {{ participant1()?.name }}
    @if (participantIsCurrentlyPlaying(participant1())) {
      <mat-icon class="material-icons-outlined currently-playing-icon">play_circle</mat-icon>
    } @else if (match().table && participant1()?.isReady && !participant1()?.drinksCollected) {
      @if (!viewOnly()) {
        <button
          class="team-action-button"
          data-cy="team1-action-button"
          mat-icon-button
          [disabled]="disableMatchEdit()"
          aria-label="Mark team drinks as picked up for this match"
          (click)="markTeamDrinksPickedUp.emit(participant1()!)"
          [matTooltip]="'Mark team drinks as picked up for this match'"
        >
          <mat-icon class="material-icons-outlined">sports_bar</mat-icon>
        </button>
      } @else {
        <div class="get-your-drinks-info display-right">Get your drinks!</div>
      }
    }
  </div>
  <div class="center-result-column">
    @if (match().table && !match()?.winnerPoints && viewOnly()) {
      <p [class.table-dark]="match().table?.name">{{ match().table?.name }}</p>
    }
    <div [matTooltip]="resultTooltip" aria-label="Enter match result">
      @if (match()?.winnerPoints) {
        @if (!viewOnly()) {
          <button
            mat-button
            [disabled]="!matchHasStarted || disableMatchEdit()"
            (click)="openMatchResultDialog()"
          >
            {{ matchResultString }}
          </button>
        } @else {
          {{ matchResultString }}
        }
      } @else {
        @if (!viewOnly()) {
          <button
            mat-icon-button
            [disabled]="!matchHasStarted || disableMatchEdit()"
            (click)="openMatchResultDialog()"
            data-cy="enter-match-results-btn"
          >
            <mat-icon>edit_note</mat-icon>
          </button>
        } @else {
          @if (!match().table) {
            vs.
          }
        }
      }
    </div>
  </div>
  <div
    class="qualification-team"
    [class.text-winner]="participant2()?.isWinner === true"
    [class.text-grey]="participant2()?.isReady !== true"
    [matTooltip]="
      participantIsCurrentlyPlaying(participant2()!) ? 'Team is currently playing' : null
    "
  >
    {{ participant2()?.name }}
    @if (participantIsCurrentlyPlaying(participant2())) {
      <mat-icon class="material-icons-outlined currently-playing-icon">play_circle</mat-icon>
    } @else if (match().table && participant2()?.isReady && !participant2()?.drinksCollected) {
      @if (!viewOnly()) {
        <button
          class="team-action-button"
          data-cy="team2-action-button"
          mat-icon-button
          [disabled]="disableMatchEdit()"
          aria-label="Mark team drinks as picked up for this match"
          (click)="markTeamDrinksPickedUp.emit(participant2()!)"
          [matTooltip]="'Mark team drinks as picked up for this match'"
        >
          <mat-icon class="material-icons-outlined">sports_bar</mat-icon>
        </button>
      } @else {
        <div class="get-your-drinks-info display-left">Get your drinks!</div>
      }
    }
  </div>
  <div>
    @if (participant1()?.drinksCollected && participant2()?.drinksCollected && !match()?.endTime) {
      <app-watch-timer [startDateUTC]="match()?.startTime"></app-watch-timer>
    } @else {
      <div class="text-grey">{{ this.calculateTimeSpent() }}</div>
    }
  </div>
</div>
